import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUserAccountV1Response } from './get-user-account-v1-response';
import { getUserAccountV1ResponseSchema } from './get-user-account-v1-response';

export async function getUserAccountV1Api(
  userId: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetUserAccountV1Response>> {
  return getRequest<IGetUserAccountV1Response>({
    path: `/sys/users/v1/${userId}/account`,
    schema: getUserAccountV1ResponseSchema,
    options,
  });
}
